module.exports = __webpack_public_path__ + "static/2-0cfb1a700d3e57e77851161aa1581a3d.png";